import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppCmsUrlsInitializationService } from 'src/app/services/app-cms-urls-initialization.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { CmsContentService } from 'src/app/services/cms-content.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ViewTermsConditionPopupComponent } from '../view-terms-condition-popup/view-terms-condition-popup.component';
import { environment } from 'src/environments/environment';
import SwiperCore, {
  A11y,
  EffectFade,
  Keyboard,
  Navigation,
  Pagination,
  SwiperOptions,
} from 'swiper'; // install Swiper modules
SwiperCore.use([Navigation, A11y, EffectFade, Keyboard, Pagination]);
@Component({
  selector: 'payment-promotion-cms-content',
  templateUrl: './payment-promotion-cms-content.component.html',
  styleUrls: ['./payment-promotion-cms-content.component.scss']
})
export class PaymentPromotionCmsContentComponent implements OnInit {

  data: any;
  @Input() cmsUrlCode: any;
  baseUrl;
  constructor(
    private APPCMSIS: AppCmsUrlsInitializationService,
    private UTS: UtilitiesService,
    private APPIS: ApplicationInitializationService,
    private CCS:CmsContentService,
    private modalController: ModalController,
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.init();
    }, 1000);
  }
  init(){
    let CMS_URLS = this.APPCMSIS.appInitializer.CMS_URLS;
    this.baseUrl = environment.HOST;
 
    let CMS_URL = null;
    let url = null;
    if (CMS_URLS && CMS_URLS.length > 0){
      CMS_URL = CMS_URLS.find((c) => c.cmsUrlCode == this.cmsUrlCode);
     url =
      this.APPIS.environmentConfig.CMS_URL_NEW_FRAGMENTPATH + CMS_URL.cmsUrlEn;
    }
    if (this.UTS.getLocaleLanguage() == 'ar')
      url =
        this.APPIS.environmentConfig.CMS_URL_NEW_FRAGMENTPATH +
        CMS_URL.cmsUrlAr;
    this.CCS.newFragemnetContentService(url).subscribe(
      (result: any) => {
        this.data = result?.data?.bauMainSectionByPath?.item;
        console.log("Pop",this.data, "dta", result);
      },
      (error) => {
      }
    );
  }

  async openBottomSheet(
    component: any,
    data?: any,
    classes = 'verification-modal modal-fullscreen eand-radius-modal'
  ) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      cssClass: classes,
    });
    return await modal.present();
  }

  viewTermsAndConditions(obj: any) {
    let node = obj?.popupInfo;
    let ctaBehaviour = obj?.ctaBehavior;

    if (ctaBehaviour == "popup") {
      this.openBottomSheet(
        ViewTermsConditionPopupComponent,
        node,
        'verification-modal modal-fullscreen eand-radius-modal eand-partail-height-screen-bottom eand-partail-height-screen-bottom-mobile'
      );
    } else {
      window.open(obj?.ctaLink, obj?.ctaBehavior);
    }
  }

  swiperPlansConfig: SwiperOptions = {
    keyboard: true,
    scrollbar: false,
    slidesPerView: 2,
    spaceBetween: 24,
    breakpoints: {
      320: { slidesPerView: 1},
      541: { slidesPerView: 1},
      768: { slidesPerView: 2},
      1024: { slidesPerView: 2},
      1920: { slidesPerView: 2},
    },
    navigation: {
      nextEl: '.payment-promotion__button-next',
      prevEl: '.payment-promotion__button-prev',
    },
  };
}

